(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"), require("jsondiffpatch"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore", "jsondiffpatch"], factory);
	else if(typeof exports === 'object')
		exports["angularMeteor"] = factory(require("underscore"), require("jsondiffpatch"));
	else
		root["angularMeteor"] = factory(root["_"], root["jsondiffpatch"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_22__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition